
import React, { ReactNode } from 'react';

import { Grid } from './styles';

import MainHeader from '../MainHeader';
import Aside from '../Aside';
import Content from '../Content';
import { Outlet } from 'react-router-dom';
import { useSidebar } from '../../hooks/useSidebar';

export type ChieldrenType = {
    children: ReactNode
}

const Layout: React.FC<{}> = () => {

    const { sideBarStatus } = useSidebar();

    return (
        <Grid menuIsOpen={sideBarStatus}>
            <MainHeader />
            <Aside />
            <Content>
                <Outlet />
            </Content>
        </Grid>
)};

export default Layout;
